import { render, staticRenderFns } from "./IdentityCard.vue?vue&type=template&id=3549438f"
import script from "./IdentityCard.vue?vue&type=script&lang=ts"
export * from "./IdentityCard.vue?vue&type=script&lang=ts"
import style0 from "./IdentityCard.vue?vue&type=style&index=0&id=3549438f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports